class CustomCtaButton {
    constructor(data) {
        this.title = data?.title ?? '';
        this.href = data?.href ?? '';
        this.enabled = data?.enabled ?? false;
    }
}

export default CustomCtaButton;
